import styled from 'styled-components'

import { media } from 'styles/media'
import typeStyle from 'styles/typeStyle'

export const SectionTitle = styled.h3`
  ${typeStyle('-ds-font-body-regular')}
  color: ${({ theme }) => theme?.['-ds-core-400']?.value};
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin-bottom: 8px;
`

export const SectionSubtitle = styled.h4`
  ${typeStyle('-ds-font-title-1-regular')}
  color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};
  margin-bottom: 24px;

  ${media.md`
    margin-bottom: 32px;
  `}
`

export const SectionParagraph = styled.p`
  ${typeStyle('-ds-font-lead-light')}
  color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};

  ${media.md`
    max-width: 640px;
    margin: 0 auto;
  `}
`

export const SectionOuter = styled.section`
  margin: 72px auto;

  ${media.md`
    text-align: center;
    margin: 72px auto 100px auto;
  `}
`

export const Padded = styled.div`
  padding: 0 16px;

  ${media.md`
    padding: 0 32px;
  `}
`
